// @core/api/endpoints/calendar/move_event.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  EventResponse,
  MoveEventRequest,
} from '../../../types/calendar';

const BASE_PATH = '/calendar';

/**
 * Move event
 * Moves an event to a different time, date, or calendar. Notifies attendees of the time change.
 */
export async function MoveEvent(
  event_id: string,
  data: MoveEventRequest,
  options?: RequestOptions
): Promise<EventResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/events/:event_id/move`;
  requestPath = requestPath.replace(':event_id', encodeURIComponent(event_id));
  const requestOptions = options;
  return client.post<EventResponse>(requestPath, data, requestOptions);
}
